import { formatDateHuman, parseDateRaw } from "../date-utils";
export const qualityIncidentDtoFields = [{
        name: "documentNumber",
        title: "Numero",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => record.qualityIncident.yearlyNumber + '/' + record.qualityIncident.year
    }, {
        name: "documentDate",
        title: "Data",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => formatDateHuman(parseDateRaw(record.qualityIncident.documentDate))
    }, {
        name: "sender",
        title: "Rilevato da",
        render: (record) => record.qualityIncident.sender
    }, {
        name: "procedureDescription",
        title: "Procedura",
        render: (record) => record.procedureDescription
    }, {
        name: "closed",
        title: "Completato",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => `<i class="material-icons">${record.qualityIncident.closed === 1 ? "check" : ""}</i>`
    }];
